import React from 'react'
import EditBrandsListItemSelect from './EditBrandsListItemSelect'

const EditBrandsListItem = ({itemData, evenOddClass, sortedBrandsList, brandValue, onUpdateBrand}) => (
    <li  className={"list-item " + evenOddClass}>
        <div className='itemdata-form-wrapper'>
            <div className='container-item'>
                <div className='title text-small-light'>{itemData.title}</div>
                <div className="select">
                    <EditBrandsListItemSelect
                        sortedBrandsList={sortedBrandsList}
                        brandValue={brandValue}
                        onUpdateBrand={onUpdateBrand}
                    />
                </div>
            </div>
        </div>
    </li>
)

export default EditBrandsListItem